module.exports = "/_next/static/images/pasta_apperance-8d6d336a4b514383290402b9474e71ed.jpg";